/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Privacy_HeadingInputs */

const ja_playdata_privacy_heading = /** @type {(inputs: Playdata_Privacy_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシーポリシー`)
};

const en_playdata_privacy_heading = /** @type {(inputs: Playdata_Privacy_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Playdata_Privacy_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_privacy_heading = /** @type {((inputs?: Playdata_Privacy_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Privacy_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_privacy_heading(inputs)
	return en_playdata_privacy_heading(inputs)
});